import React from 'react';
import { Alert, Modal, ModalFooter } from '@/components/common';
import { UserCredentials } from '@/models';

interface UserCredentialsModalProps {
  isOpen: boolean;
  credentials: UserCredentials | null;
  onClose: () => void;
}

export const UserCredentialsModal: React.FC<UserCredentialsModalProps> = ({
  isOpen,
  credentials,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnBackdropClick={false}
      title="User Created - Credentials"
      footer={
        <ModalFooter onCancel={onClose} confirmText="Done" onConfirm={onClose} />
      }
    >
      {credentials && (
        <div>
          <Alert variant="warning">
            <i className="fas fa-exclamation-triangle me-2"></i>
            Please save these credentials. The temporary password will not be shown again.
          </Alert>
          <div className="mb-3">
            <label className="form-label fw-bold">Username</label>
            <div className="form-control bg-light">{credentials.username || '-'}</div>
          </div>
          <div className="mb-3">
            <label className="form-label fw-bold">Temporary Password</label>
            <div className="form-control bg-light font-monospace">
              {credentials.temporaryPassword || '-'}
            </div>
          </div>
          {credentials.requiresPasswordChange && (
            <small className="text-muted">
              <i className="fas fa-info-circle me-1"></i>
              User will be required to change their password on first login.
            </small>
          )}
        </div>
      )}
    </Modal>
  );
};
